
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/cms/[...cmsPage]",
      function () {
        return require("private-next-pages/[lang]/cms/[...cmsPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/cms/[...cmsPage]"])
      });
    }
  